const { EventEmitter2: EventEmitter } = require('eventemitter2');
const defaultConfig = require('./config');

class Events extends EventEmitter {
  constructor(config = {}) {
    const eventsConfig = Object.assign({}, defaultConfig, config);
    super(eventsConfig);
  }
}

module.exports = Events;
